import { Alert, AlertDescription, AlertTitle } from '@racefront/shadcn-ui'
import { AlertCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { UserAccount } from '../../../types/user'
import { FALLBACK_PHONE } from '../user-form/constants'
import { UserFormRef } from '../user-form/user-form'

type IncompleteProfileAlertProps = {
  userData?: Partial<UserAccount>
  formRef: React.RefObject<UserFormRef>
}

export function IncompleteProfileAlert({ userData, formRef }: IncompleteProfileAlertProps) {
  const [missingFields, setMissingFields] = useState<string[]>([])

  useEffect(() => {
    if (userData && userData.profileComplete === false) {
      const missing: string[] = []

      // Check required fields based on schema
      if (!userData.email || !userData.email.trim()) missing.push('Email')
      if (!userData.phoneNumber || !userData.phoneNumber.trim() || userData.phoneNumber === FALLBACK_PHONE)
        missing.push('Phone Number')
      if (!userData.locale || !userData.locale.trim()) missing.push('Language')
      if (!userData.lastname || !userData.lastname.trim()) missing.push('Last Name')
      if (!userData.birthdate || !userData.birthdate.trim()) missing.push('Birth Date')
      if (!userData.gender || !userData.gender.trim() || userData.gender === '0') missing.push('Gender')

      setMissingFields(missing)

      // Trigger form validation
      if (formRef.current) {
        formRef.current.triggerValidation()
      }
    } else {
      setMissingFields([])
    }
  }, [userData, formRef])

  if (missingFields.length === 0) {
    return null
  }

  return (
    <Alert className="bg-destructive/80 mt-6">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>
        <FormattedMessage id="account.incomplete_profile.title" defaultMessage="Profile Incomplete" />
      </AlertTitle>
      <AlertDescription>
        <FormattedMessage
          id="account.incomplete_profile.description"
          defaultMessage="Please complete the following required fields to finish your profile:"
        />
        <ul className="mt-2 list-inside list-disc">
          {missingFields.map((field, index) => (
            <li key={index}>{field}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  )
}
